import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  soldoutInCustompageList,
  soldoutInCustompageListVariables
} from "./types/soldoutInCustompageList";
const SoldoutproductvariantsListQuery = gql`
  query soldoutInCustompageList(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: SoldoutInCustompageFilterInput
    $sortBy: SoldoutInCustompageSortingInput
  ) {
    soldoutInCustompage(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
      sortBy: $sortBy
    ) {
      totalCount
      edges {
        node {
          id
          soldoutTime
          custompage {
            id
            title
            url
          }
          productVariant {
            id
            name
            sku
            trackInventory
            isPublished
            product {
              id
              name
            }
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;
export const useSoldoutproductvariantsListQuery = makeQuery<
  soldoutInCustompageList,
  soldoutInCustompageListVariables
>(SoldoutproductvariantsListQuery);
